import { __awaiter } from "tslib";
import { DI } from '@microsoft/fast-foundation';
import { MessageType } from '../connect/message';
import { logger } from '../utils';
import { DefaultDatasource } from './datasource';
/**
 * Default EntityDatasource DI implementation.
 *
 * @alpha
 */
export class DefaultEntityDatasource extends DefaultDatasource {
    constructor() {
        super(...arguments);
        this.entityCache = [];
        this.entityMap = new Map(); // < TODO: Review map > array management performance
        this.rowId = 'ROW_REF';
        /** {@inheritDoc EntityDatasource.initialize} */
        this.initialize = (init) => __awaiter(this, void 0, void 0, function* () {
            this.disconnect();
            this.options = Object.assign({}, init.options);
            this.mapper = init.mapper;
            this.initialized = yield this.init(this.options, init.fetchMeta);
            if (!this.initialized) {
                logger.debug(`EntityDatasource init failed for ${this.options.resourceName}`);
                return false;
            }
            this.subscription = this.stream.subscribe((result) => {
                this.sourceRef = result.SOURCE_REF;
                this.subscriptionLoggedOff = result.MESSAGE_TYPE === MessageType.LOGOFF_ACK;
                const dataServerRow = result.ROW;
                if (this.subscriptionLoggedOff || !dataServerRow) {
                    return;
                }
                this.updateCache(this.config.dataServerResultFilter(result, this.rowId));
            });
            return true;
        });
        /** {@inheritDoc EntityDatasource.disconnect} */
        this.disconnect = () => {
            var _a;
            (_a = this.subscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            this.entityCache = [];
        };
    }
    /** {@inheritDoc EntityDatasource.cache} */
    get cache() {
        if (!this.initialized) {
            throw new Error('Please initialize EntityDatasource before querying.');
        }
        return this.entityCache;
    }
    /** {@inheritDoc EntityDatasource.isEmpty} */
    get isEmpty() {
        return this.entityCache.length === 0;
    }
    updateCache(result) {
        var _a;
        if (this.isEmpty) {
            /**
             * TODO: prime empty cache? Discuss with the guys
             * if (this.rowId !== 'ROW_REF')...
             * result.inserts...
             * return;
             */
        }
        (_a = result.deletes) === null || _a === void 0 ? void 0 : _a.forEach((rowDTO) => {
            const key = rowDTO[this.rowId];
            this.entityMap.delete(key);
        });
        this.processRowDataUpdate(result.inserts, true);
        this.processRowDataUpdate(result.updates);
        // TODO
        const dtos = [{}];
        this.entityCache = dtos.map((dto) => this.mapper.fromDTO(dto));
    }
    processRowDataUpdate(rowData, inserting = false) {
        rowData.forEach((rowDTO) => {
            // const insertEntity = this.mapper.fromDTO(insertRow);
            const key = rowDTO[this.rowId];
            const prevEntity = this.entityMap.get(key);
            if (prevEntity && inserting) {
                throw new Error('Existing entity found in map while inserting.');
            }
            const rowEntity = this.mapper.fromDTO(rowDTO);
            const nextEntity = prevEntity ? Object.assign(Object.assign({}, prevEntity), rowEntity) : rowEntity;
            this.entityMap.set(key, nextEntity);
        });
    }
}
/**
 * EntityDatasource DI key.
 *
 * @privateRemarks
 * Marked as internal to stop api-extractor becoming confused cross-linking tokens with the same name.
 *
 * @internal
 */
export const EntityDatasource = DI.createInterface((x) => x.transient(DefaultEntityDatasource));
